import React, { useState, useEffect } from 'react';
import DatePicker from 'react-datepicker';
import { format, parseISO, set } from 'date-fns';
import 'react-datepicker/dist/react-datepicker.css';
import { showToast } from '../toastUtils';
import './SubmitProgressClaimiframe.css';
import FullscreenLoader from '../FullscreenLoader';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { queuedApiFetch, apiFetch } from '../api';


function SubmitProgressClaimiframe() {
        
     var amt_error = false;
     var from_dt_error = false;
     var until_dt_error = false;
     var submitLoading = false;
    
    const getProjectDetails = localStorage.getItem('projectDetails');
    const selectedProjectDetail = JSON.parse(getProjectDetails);
    const projectNum = selectedProjectDetail.projectNumber;
    const projectName = selectedProjectDetail.projectName;
    const getUserDetails = localStorage.getItem('userDetails');
    const userDetails = getUserDetails ? JSON.parse(getUserDetails): '';
    const company_id = userDetails ? userDetails.default_company_id : '';
    const user_id = userDetails ? userDetails.id : '';
    const [userCompany, setUserCompany] = useState();
    const [executedcounts, setexecutedcount] = useState();
    const getUserEmail = localStorage.getItem('userEmail');
    const getUserCompanyDetails =userCompany;
    const folder_urn=selectedProjectDetail.URN_List.progress_claim;
    const [loading, setLoading] = useState(true);
    const [revised, setRevised] = useState(0); // Global state
    const [actualcost, setActualcost] = useState(0); // Global state
    const [data_loaded, set_Data_Loaded] = useState(false); // Global state
    const [Company, setCompany]= useState(0); // Global state
    const [past_Claim, setClaim]= useState(0); // Global state
    // console.log('User Company Name:', userCompany);
    // var revised = 0;
    // var actualcost = 0;
    var company = '';
    var claim = 0;
    var proj_start_date;
    var proj_end_date;    
    var start_date;
    var end_date;
    var payment_data = false;
    // var data_loaded = false;
  
    let parametervalue;
  
    //Parameter passing
    if(getUserCompanyDetails==="NUS"){
      parametervalue=1;
    }else{
      parametervalue=0;
    }

  let p_access = selectedProjectDetail?.Proj_Access?.proj_access_level;
  let p_roles = selectedProjectDetail?.Proj_Access?.proj_role.join(", ");
  let proj_name=selectedProjectDetail?.projectName;

  let qs_params = `nususer=${parametervalue}&project_admin=${(p_access) ? 1 : 0}&project_roles=${encodeURIComponent(p_roles)}&project_name=${proj_name}`;
    
const submit_disable = () =>
{
    var dis = !data_loaded || (amt_error||from_dt_error||until_dt_error) || submitLoading || claim == 0 || !start_date || !end_date;
    console.log('submitLoading ' , submitLoading );
    console.log('clm ' , claim );
    console.log('sdt ' , !start_date);
    console.log('DIS ' , dis);
    return dis;
}

const fetchUserCompany = async () => {
  const requestOptions = {
    method: 'GET',
    //headers: new Headers({ 'ngrok-skip-browser-warning': '69420' })
  };
   try {
    const response = await queuedApiFetch(`/user/getuserprofile?emailid=${getUserEmail}`, requestOptions);
    const data = await response;

    if (data.apistatus.Status_Code === 200 && data.apistatus.Status_Description.toLowerCase() === 'success') {
      setUserCompany(data.data.company_name);
    }
  } catch (error) {
    console.error('Error fetching data:', error);
  } finally {
    // setLoading(false); 
  }
}

useEffect(() => {
  const fetchData = async () => {
    await fetchUserCompany();
  };
  fetchData();
}, []);


    const getPaymentClaims = async () => {
      // setLoading(true); // Start loading
     
      const requestOptions = {
        method: 'GET',
        //headers: new Headers({ 'ngrok-skip-browser-warning': '69420' })
      };
    
      try {
        const response = await queuedApiFetch(`/payment/payment_claims?project_id=${projectNum}`, requestOptions);
        const data = await response;
        
        if (data.apistatus.Status_Code === 200 && data.apistatus.Status_Description.toLowerCase() === 'success') {
          const filter_data=data.data.filter(x=>x.User_name==userDetails.name);
          //console.log(userDetails.name +' data count',filter_data.length);
          setClaim(filter_data.length);
          // console.log('ZZZ',data.data.length);
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        // setLoading(false); // End loading
      }
    };

    
const payment_claim_data  = async () => {
     
     if (payment_data)
         return;
     
     payment_data = true;
    const requestOptions = {
      method: 'GET',
      //headers: new Headers({ 'ngrok-skip-browser-warning': '69420' })
    };
     try {
      const response = await queuedApiFetch(`/payment/payment_claim_data?project_id=${projectNum}&company_id=${company_id}&user_id=${user_id}`, requestOptions);
      const data = await response;
  
      if (data.revised!=null) {
      //  revised = data.revised;
      //  actualcost = data.actualcost;
       setRevised(data.revised);
       setActualcost(data.actualcost);
       setCompany(data.company);
       company = data.company;
       proj_start_date = data.proj_start_date;
       proj_end_date = data.proj_end_date;
       document.getElementById("revised").textContent= data.revised;
       document.getElementById("actualcost").textContent= data.actualcost;
       set_Data_Loaded(true);
      //  console.log('Data loaded successfully:', data_loaded);
      }
      setexecutedcount(data.executed_count);
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false); // End loading
    }
  }
  useEffect(() => {
    getPaymentClaims();
   payment_claim_data();
  }, []);    
  
   const NewClaim = async () => {

    if (executedcounts === 0) {
      const companyName = userCompany;
      showToast.error(`${companyName} contract not executed`);
      return;
    }

    if (claim == 0) {
      showToast.error(`Kindly provide a valid claim amount`);
      return;
    }
    if (start_date == undefined || start_date == null || start_date == '') {
      showToast.error(`Kindly select a valid Start Date`);
      return;
    }
    if (end_date == undefined || end_date == null || end_date == '') {
      showToast.error(`Kindly select a valid End Date`);
      return;
    }
    
    var dis = !data_loaded || (amt_error||from_dt_error||until_dt_error) || submitLoading || claim == 0 || !start_date || !end_date;
  
      if (dis)
      {         
        // console.log('data load', !data_loaded);
        // console.log('amt_error', amt_error);
        // console.log('from_dt_error', from_dt_error);
        // console.log('until_dt_error', until_dt_error);
        // console.log('submitLoading', submitLoading);
        // console.log('claim', claim);
        // console.log('start_date', !start_date);
        // console.log('end_date', !end_date); 
            return;
      }
            
    if (submitLoading) return; // Prevent multiple submissions if already loading
  
    submitLoading = true;
  
    try {
      const sendData = {
        project_id: projectNum ,
        Project_name: projectName ,
        user_id: user_id ,
        User_name: userDetails.name ,
        company_id : company_id,
        Company: Company,
        claim_amount: claim ,
        work_done_from: start_date ,
        work_done_until: end_date ,
        claim_no: 0 ,
        claim_status: 'New' ,  
        total_claims: actualcost      
      };
      const requestOptions = {
        method: 'POST',
        // headers: {
        //   'Content-Type': 'application/json',
        //   'ngrok-skip-browser-warning': '69420',
        // },
        body: JSON.stringify(sendData),
      };
  
      const response = await queuedApiFetch(`/payment/insertclaim`,
        requestOptions
      );
      const result = await response;
  
      if (result.apistatus.Status_Code === 200 && result.apistatus.Status_Description.toLowerCase() === 'success') {
        showToast.success('Data saved successfully');
      } else {
        showToast.error(result.apistatus.Status_Description || 'Error occurred. Please try again later');
      }
    } catch (error) {
      console.error('Error saving data:', error);
      showToast.error('An error occurred while saving data.');
    } finally {
      submitLoading = false;
    }
  };
  
  return (
    <html>
    <body style={{display: "flex", justifyContent: "center", alignItems: 'center', margin: 0, width:"70vw", background: "#f0f0f0", height: "100vh"}}>  
    {loading && <FullscreenLoader />} 
        <div className="submit-progress-claim-container">
            <div className="row">
                <div className="label dark-grey">Total contract sum</div>
                <div className="value"><span id="revised"></span> SGD</div>
            </div>
            <div className="row">
                <div className="label dark-grey">Accumulated claimed sum (upto Claim {past_Claim})</div>
                <div className="value"><span id="actualcost"></span> SGD</div>
            </div>
            {/* <div className="row"></div> */}
            <div className="row">
                <div className="label navy-blue">New Claim Sum <br></br>(Claim {past_Claim+1})</div>
                <div className="value">   
                <input
                  id="claim"
                  style={{ width: '120px', border: '1px solid #ccc' }}
                  type="number"
                  min="0"
                  onKeyDown={(e) => {
                    if (e.key === '-' || e.key === 'e' || e.key === '+') {
                      e.preventDefault();
                    }
                  }}
                  onInput={(e) => {
                    const claimInput = document.getElementById('claim');
                    let value = e.target.value;

                    if (value < 0) {
                      e.target.value = 0;
                      return;
                    }

                    const numericValue = parseFloat(value);
                    const maxAllowed = revised - actualcost;

                    if (numericValue > maxAllowed) {
                      e.target.value = value.slice(0, -1);
                      claimInput.style.borderColor = 'red';
                      amt_error = true;
                      showToast.error('Claim amount greater than available amount.');
                      return;
                    }

                    amt_error = false;
                    claim = numericValue;
                    claimInput.style.borderColor = 'black';
                  }}
                />
                   
                   SGD</div>
            </div>
           <div className="row">
                <div className="label navy-blue">Work Executed From</div>
                <div className="value"><input style={{width: '165px'}} id="start_date" type="date"
                       onChange={(e) => {
                           const start_dateInput = document.getElementById('start_date');
                           const end_dateInput = document.getElementById('end_date');
                              start_date = e.target.value;
                              
                               if (end_dateInput.value != "" && start_date > end_dateInput.value)
                              {
                                
                                start_dateInput.style.borderColor = 'red';
                                from_dt_error = true;
                                showToast.error('Work execution from date is greater than Work execution until date.');
                                return;
                              }
                              
                              
                              if (start_date < proj_start_date)
                              {
                                
                                start_dateInput.style.borderColor = 'red';
                                from_dt_error = true;
                                showToast.error('Work execution from date is less than Project start date.');
                                return;
                              }
                              
                              
                               if (start_date > proj_end_date)
                              {
                                
                                start_dateInput.style.borderColor = 'red';
                                from_dt_error = true;
                                showToast.error('Work execution from date is greater than Project end date.');
                                return;
                              }
                              start_dateInput.style.borderColor = 'black';
                             from_dt_error = false;
                            }}
                /></div>
            </div>            
            <div className="row">
                <div className="label navy-blue">Work Executed Until</div>
                <div className="value"><input style={{width: '165px'}} id="end_date" type="date"
                          onChange={(e) => {
                              const start_dateInput = document.getElementById('start_date');
                              const end_dateInput = document.getElementById('end_date');
                              end_date = e.target.value;
                              
                              if (start_dateInput.value != "" && end_date < start_dateInput.value)
                              {
                                
                                end_dateInput.style.borderColor = 'red';
                                until_dt_error = true;
                                showToast.error('Work execution until date is less than Work execution from date.');
                                return;
                              }
                              
                              
                              if (end_date > proj_end_date)
                              {
                                
                                end_dateInput.style.borderColor = 'red';
                                until_dt_error = true;
                                showToast.error('Work execution until date is greater than Project end date.');
                                return;
                              }
                              
                               if (end_date < proj_start_date)
                              {
                                
                                end_dateInput.style.borderColor = 'red';
                                until_dt_error = true;
                                showToast.error('Work execution until date is less than Project start date.');
                                return;
                              }
                              
                              
                              end_dateInput.style.borderColor = 'black';
                             until_dt_error = false;
                            }}                
                /></div>
            </div>
            <div className="row">
            <button
                className="light-blue"
                onClick={() =>
                  window.open(
                    `https://acc.autodesk.com/docs/files/projects/${projectNum}?folderUrn=${folder_urn}&viewModel=detail&moduleId=folders&${qs_params}&menu=Construction_Progress claims_Submit Progress claim`,
                    '_blank',
                  )
                }
              >
                Upload References
              </button>

            </div>
            <div className="row" style={{justifyContent: 'flex-end'}}>
                <button id="submit" onClick={NewClaim}>Submit</button>
            </div>
        </div>
    </body>
    </html>
  );
}

export default SubmitProgressClaimiframe;
